import {
    GET_PRODUCT_DETAILS,
    GET_PRODUCT_DETAILS_SUCCESS,
    GET_PRODUCT_DETAILS_ERROR,
    SORT_PRODUCT_DETAILS,
} from '../actions';

const initialState = {
    data: null,
    initialList: null,
    loading: true,
    statusCode: 0,
    statusMessage: '',
};

const productDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRODUCT_DETAILS:
            return {
                ...state,
                loading: true,
            };
        case GET_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                data: action.payload.productDetails,
                initialList: action.payload.productDetails,
                statusCode: action.payload.statusCode,
                statusMessage: action.payload.statusMessage,
                loading: false,
            };
        case GET_PRODUCT_DETAILS_ERROR:
            return {
                ...state,
                data: null,
                initialList: null,
                loading: false,
                statusCode: action.statusCode,
            };
        case SORT_PRODUCT_DETAILS:
            return {
                ...state,
                data: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default productDetailsReducer;
